// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"0767e37e","542":"cba00fe6","857":"dc2fa3a4"}[chunkId] + ".chunk.css";
};